import { FC, useEffect } from "react";
import { useDispatch } from "react-redux";
import { MuiModal, MuiTypography } from "../..";
import { useDeleteClientSavedFiltersMutation } from "../../../api/services/client/clientApis";
import { MenuListParams } from "../../../api/services/client/models";
import { useSiteCore } from "../../../hooks/useSiteCore";
import {
  toggleLoader,
  toggleToast,
} from "../../../redux/slices/appState/appStateSlice";
import { filterSiteCoreKeys } from "../siteCore/SiteCoreKeys";
import { DeleteFilterModalWrapper } from "./DeleteFilter.style";

interface DeleteFilterProps {
  showModal: boolean;
  handleModalClose: () => void;
  handlePrimaryButtonClick: () => void;
  filterToDelete: MenuListParams;
  refetchListOfFilters: () => void;
}

export const DeleteFilterModal: FC<DeleteFilterProps> = ({
  showModal,
  handleModalClose,
  handlePrimaryButtonClick,
  filterToDelete,
  refetchListOfFilters,
}) => {
  const dispatch = useDispatch();
  const { commonLabels, fetchLabel } = useSiteCore();

  const {
    mutateAsync: deleteSavedFilter,
    isSuccess,
    isPending: isDeletePending,
    isError: isDeleteError,
  } = useDeleteClientSavedFiltersMutation();

  const fetchFilterPopupLabel = (key: string) => {
    return fetchLabel(filterSiteCoreKeys.filterPopupKey, key);
  };

  useEffect(() => {
    dispatch(
      toggleLoader({
        isVisible: isDeletePending,
      }),
    );
    return () => {
      dispatch(toggleLoader({ isVisible: false }));
    };
  }, [isDeletePending]);

  useEffect(() => {
    if (isSuccess) {
      handlePrimaryButtonClick();
      dispatch(
        toggleToast({
          open: true,
          message: fetchFilterPopupLabel(
            filterSiteCoreKeys.filterDeletedMessage,
          ),
        }),
      );
      refetchListOfFilters();
    }
    if (isDeleteError) {
      dispatch(
        toggleToast({
          open: true,
          message: commonLabels.someThingWentWrongPleaseTryAgainLater,
          type: "error",
        }),
      );
      dispatch(toggleLoader({ isVisible: false }));
    }
  }, [isSuccess, isDeleteError]);

  const handleDeleteConfirmation = () => {
    deleteSavedFilter([filterToDelete.id]);
  };

  return (
    <MuiModal
      open={showModal}
      onClose={handleModalClose}
      title={fetchFilterPopupLabel(filterSiteCoreKeys.deleteFilter)}
      primaryButtonTitle={commonLabels.yes}
      secondaryButtonTitle={commonLabels.no}
      onSecondaryButtonClick={handleModalClose}
      onPrimaryButtonClick={handleDeleteConfirmation}
    >
      <DeleteFilterModalWrapper>
        <MuiTypography
          id="modal-description"
          variant="h3"
          component={"h3"}
          className="confirm-message"
        >
          {fetchFilterPopupLabel(filterSiteCoreKeys.deleteFilterActionMessage)}
        </MuiTypography>
        <MuiTypography variant="h3Bold" component={"h3"} className="item-name">
          {filterToDelete?.name}
        </MuiTypography>
      </DeleteFilterModalWrapper>
    </MuiModal>
  );
};
